<div id="divSelectedAsset{{fieldName}}{{key}}" [class]="fullWidthClass+' selectedAsset map-common-wrap'">
    
    <mat-form-field #formFieldContainer  floatLabel="always" appearance="none" class="map-label">
        <mat-label
            #labelContainer  (click)="toggleTooltip(tooltip)"
            class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">
        {{componentDefinition?.label}}
        </mat-label>

        <div class="labelToolTipContainer" 
            #tooltip="matTooltip"
            matTooltip="{{componentDefinition.label}}"
            [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
        </div>

        <input matInput [hidden]="true"
            [id]="componentDefinition?.name" [name]="componentDefinition?.name"
            />
    </mat-form-field>
    

    <div class="address-map-row f-flex f-flex-row" [class]="showInPrint">
            <div class="ft-address-left-panel address-panel" [hidden]="hideAddress">


                <div *ngIf="!hideAddress" class="left-panel-address f-flex f-flex-row f-flex-wrap">

                    <div [id]="keyName+'GeoAutoComplete'" [class]="keyName+'GeoAutoComplete' " style="width: 100%">
                        <geo-auto-complete [autocompleteBox]="autoCompleteBox"
                            [keyName]="keyName" [disabled]="disabled"
                            (getStreetData)="onGetStreetData($event)" (removeStreetCb)="onRemoveStreetCb()"
                            [geocodeSearchService]="geocodeSearchService"
                            [EPSG]="mapFunc?.EPSG" [mapFunc]="mapFunc" [componentDefinition]="componentDefinition"
                            (init)="initGeoAutoComplete($event)"
                            [isParentReady]="isComponentReady"
                            [contextParams]="mapFunc?.contextParams"
                            [pageSize]="mapFunc?.pageSize"
                            [document]="document"
                            [template]="template"
                            [fieldName]="fieldName"
                        >
                        </geo-auto-complete>
                    </div>

                    <div [id]="keyName+'StreetDataWrapper'" style="width: 100%">
                        <street-data [keyName]="keyName"
                            [disabled]="disabled"
                            [disableAddress] = "disableAddress"
                            [isParentReady]="isComponentReady"
                            [template]="template"
                            [fieldName]="fieldName"
                            [registeredControlName]="registeredControlName"
                            [parentComponent]="this"
                            (evtInit)="onStreetDataComponentInit($event)"
                            (evtSetStreetDataStr)="onSetStreetDataStr()"
                            (evtPropertyValueChange)="onPropertyValueChange()"
                            (evtValueChangedAddress)="onValueChangedAddress()"
                            (evtCoordinateValueChange)="onCoordinateValueChange()"
                        ></street-data>
                    </div>

                </div>
                <!--if there will changes in [div class="ft-address-autocomplete"] here,
                change also bellow [div class="ft-address-autocomplete"] element.  -->

                
                <div class="hideAddress-1">                    
                    <div class="ft-address-autocomplete" *ngIf="!hideAddress">
                        <div #dvPrimarySelection [id]="keyName+'primarySelectRows'">
                            <span *ngFor="let astPri of assets.primary;trackBy:trackByIdPrimary" class="ui-select-match-item"
                                [id]="astPri.properties.linkAssets[0].documentId">
                                <span>
                                    <a [attr.href]="'form/'+astPri.properties.linkAssets[0].documentId" >
                                        {{astPri.properties.linkAssets[0].name}}
                                    </a>
                                </span>
                                <span class="close" (click)="removePrimaryAsset(astPri)"
                                [hidden]="disabled">&nbsp;&#10006;</span>
                            </span>
                        </div>
                        <form #fsPrimary="ngForm">
                            <mat-form-field appearance="standard">
                                <input matInput placeholder="{{assets.primary.length > 0 ? '': 'Primary asset'}}" [matAutocomplete]="autoprimary" name="astPrimary"
                                #astPrimary="ngModel" [(ngModel)]="currentPrimary" (input)="searchAssetUI($event.target.value, 'primaryAsset')"
                                [readonly]="disabled" [ngStyle]="disabled ? {'cursor':'not-allowed'} : ''">
                            </mat-form-field>
                            <mat-autocomplete class="sc-primary-asset" classlist="sc-primary-asset" #autoprimary="matAutocomplete"
                             [displayWith]="displayAsset('primaryAsset')"  (optionSelected)="selectPrimary($event.option.value)">
                                <mat-option *ngFor="let resPri of resultsPrimary" [value]="resPri">
                                    {{resPri.properties.linkAssets[0].name}}
                                </mat-option>
                            </mat-autocomplete>
                        </form>                        
                    </div> <!-- end !hideAddress-->

                    <div>
                        <div class="ft-address-autocomplete" *ngIf="!hideAddress">
                            <div #dvSecondarySelection [id]="keyName+'secondarySelectRows'">
                                <span *ngFor="let astSec of assets.secondary;trackBy:trackByIdSecondary" class="ui-select-match-item"
                                [id]="astSec.properties.linkAssets[0].documentId">
                                    <span>
                                        <a [attr.href]="'form/'+astSec.properties.linkAssets[0].documentId" >
                                            {{astSec.properties.linkAssets[0].name}}
                                        </a>
                                    </span>
                                    <span [hidden]="noSecondaryAssetSelection || disabled" class="close"
                                     (click)="removeSecondaryAsset(astSec)">&nbsp;x</span>
                                </span>
                            </div>
                            <form #fsSecondary="ngForm">
                                <mat-form-field appearance="standard">
                                    <input matInput placeholder="{{assets.secondary.length > 0 ? '': 'Secondary asset'}}" [matAutocomplete]="autosecondary" name="astSecondary"
                                    #astSecondary="ngModel" [(ngModel)]="currentSecondary" (input)="searchAssetUI($event.target.value, 'secondaryAsset')"
                                    [readonly]="(disabled || noSecondaryAssetSelection)"
                                    [ngStyle]="(disabled || noSecondaryAssetSelection) ? {'cursor':'not-allowed'} : ''">
                                </mat-form-field>
                                <mat-autocomplete class="sc-secondary-asset" classlist="sc-secondary-asset" #autosecondary="matAutocomplete" [displayWith]="displayAsset('secondaryAsset')"  (optionSelected)="selectSecondary($event.option.value)">
                                    <mat-option *ngFor="let resSec of resultsSecondary" [value]="resSec">
                                        {{resSec.properties.linkAssets[0].name}}
                                    </mat-option>
                                </mat-autocomplete>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div #info id="info" class = "map-popover"
                [style.left]="mapFunc?.infoPosition?.left" [style.top]="mapFunc?.infoPosition?.top"
                [style.display]="mapFunc?.isPopoverOpen? 'table': 'none'"
                [style.zIndex]="toolTipZIndex" >
                <div class="popover-inner" [style.zIndex]="toolTipZIndex">
                    <div #tooltipInfo [id]="keyName+'tooltipInfo'" [style.zIndex]="toolTipZIndex"
                        [class]="mapFunc?.isToolTipScroll ? 'tooltip-scroll popover-content' : 'popover-content'">
                    </div>
                </div>
            </div>
            <div #info1 id="info1" class = "map-popover"
                [style.left]="mapFunc?.infoRadioPosition?.left" [style.top]="mapFunc?.infoRadioPosition?.top"
                [style.display]="mapFunc?.isPopupRadioOpen? 'table': 'none'"
                [style.zIndex]="toolTipZIndex" >
                <div class="popover-inner" [style.zIndex]="toolTipZIndex">
                    <div #radioPopupInfo [id]="keyName+'radioPopupInfo'" [style.zIndex]="toolTipZIndex"
                    [class]="isRadioPopupScroll ? 'tooltip-scroll popover-content' : 'popover-content'">
                        <div *ngFor="let post of postList" [innerHtml]="post | sanitizeHtml"></div>
                        <button type="button" class="btn" style="color:black;" (click)="selectAssetPopup()" [hidden]="disablePopupOkButton">OK</button>
                    </div>
                </div>
            </div>
            <div #infoCluster id="infoCluster" class = "map-popover"
                [style.left]="mapFunc?.infoClusterPosition?.left" [style.top]="mapFunc?.infoClusterPosition?.top"
                [style.display]="mapFunc.isPopupClusterOpen? 'table': 'none'"
                [style.zIndex]="toolTipZIndex" >
                <div class="popover-inner" [style.zIndex]="toolTipZIndex">
                    <div #clusterPopupInfo [id]="keyName+'clusterPopupInfo'" [style.zIndex]="toolTipZIndex"
                    [class]="isClusterPopupScroll ? 'tooltip-scroll popover-content' : 'popover-content'">
                        <div *ngFor="let post of clusterList" [innerHtml]="post | sanitizeHtml"></div>
                        <button type="button" class="btn" style="color:black;" [hidden]="!allowSelectAsset" (click)="closeClusterPopup(false)" >Close</button>
                        <button type="button" class="btn" style="color:black;" [hidden]="allowSelectAsset" (click)="closeClusterPopup(true)" >OK</button>
                    </div>
                </div>
            </div>
            <div class="map-panel ft-map-wrap" [id]="keyName+'MapWrapper'"
             [style.height.px]="mapFunc?.mapHeight" style="width:100%;">
                <div [id]="keyName+'gblMap'" #mapWrapper style="width:100%; height:100%;position: relative;">
                    <!-- div info & info1 will put here after render map -->
                </div>
            </div>

    </div>
    <!--if hideAddress=true show this div element -->

    <div *ngIf="hideAddress" class="hideAddress-2">
        <!--[div class="ft-address-autocomplete"] here is a duplicate html code from above element [div class="ft-address-autocomplete"].  -->
        <div class="ft-address-autocomplete">
            <div #dvPrimarySelection [id]="keyName+'primarySelectRows'">
                <span *ngFor="let astPri of assets.primary;trackBy:trackByIdPrimary" class="ui-select-match-item"
                    [id]="astPri.properties.linkAssets[0].documentId">
                    <span>
                        <a [attr.href]="'form/'+astPri.properties.linkAssets[0].documentId" >
                            {{astPri.properties.linkAssets[0].name}}
                        </a>
                    </span>
                    <span class="close" (click)="removePrimaryAsset(astPri)"
                    [hidden]="disabled">&nbsp;x</span>
                </span>
            </div>
            <form #fsPrimary="ngForm">
                <mat-form-field appearance="standard">
                    <input matInput placeholder="{{assets.primary.length > 0 ? '': 'Primary asset'}}" [matAutocomplete]="autoprimary" name="astPrimary"
                    #astPrimary="ngModel" [(ngModel)]="currentPrimary" (input)="searchAssetUI($event.target.value, 'primaryAsset')"
                    [readonly]="disabled" [ngStyle]="disabled ? {'cursor':'not-allowed'} : ''">
                
                    <mat-autocomplete #autoprimary="matAutocomplete" [displayWith]="displayAsset('primaryAsset')"  (optionSelected)="selectPrimary($event.option.value)">
                        <mat-option *ngFor="let resPri of resultsPrimary" [value]="resPri">
                            {{resPri.properties.linkAssets[0].name}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>   
            </form>
        </div>


        <div>
            <div class="ft-address-autocomplete">
                <div #dvSecondarySelection [id]="keyName+'secondarySelectRows'">
                    <span *ngFor="let astSec of assets.secondary;trackBy:trackByIdSecondary" class="ui-select-match-item"
                     [id]="astSec.properties.linkAssets[0].documentId">
                        <span>
                            <a [attr.href]="'form/'+astSec.properties.linkAssets[0].documentId" >
                                {{astSec.properties.linkAssets[0].name}}
                            </a>
                        </span>
                        <span [hidden]="noSecondaryAssetSelection || disabled" class="close"
                         (click)="removeSecondaryAsset(astSec)">&nbsp;x</span>
                    </span>
                </div>
                <form #fsSecondary="ngForm">
                    <mat-form-field appearance="standard">
                        <input matInput placeholder="{{assets.secondary.length > 0 ? '': 'Secondary asset'}}" [matAutocomplete]="autosecondary" name="astSecondary"
                        #astSecondary="ngModel" [(ngModel)]="currentSecondary" (input)="searchAssetUI($event.target.value, 'secondaryAsset')"
                        [readonly]="(disabled || noSecondaryAssetSelection)"
                        [ngStyle]="(disabled || noSecondaryAssetSelection) ? {'cursor':'not-allowed'} : ''">
                    
                        <mat-autocomplete #autosecondary="matAutocomplete" [displayWith]="displayAsset('secondaryAsset')"  (optionSelected)="selectSecondary($event.option.value)">
                            <mat-option *ngFor="let resSec of resultsSecondary" [value]="resSec">
                                {{resSec.properties.linkAssets[0].name}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </form>
            </div>
        </div>
    </div>
</div> <!-- end sc-selected-asset -->
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
